/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
import utils from './helpers/utilities'
import ThemeSwitcher from './components/ThemeSwitcher'

import store from './store';

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Tabs from 'vue-tabs-component';
import "../plugins/vee-validate";
import "../plugins/sweetAlert";
import VueScrollTo from 'vue-scrollto';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
// import "../plugins/VueHtmlToPaper";
import "../../node_modules/bootstrap/js/dist/tab.js";
// import "./services/fireBase";

import excel from 'vue-excel-export'
import onlyInt from 'vue-input-only-number';
// import VueConfirmDialog from 'vue-confirm-dialog';
import VueConfirmDialog from 'vue-confirm-dialog/src/index';
import constants from '@/utils/constants';
import platformConstants from '@/utils/platformConstants';

import VueRouter from 'vue-router'

Vue.prototype.$utils = utils;
Vue.prototype.$constants = constants;
Vue.prototype.$platformConstants = platformConstants;

//mixins
import globalMixin from "./mixins/globalMixin"
import ordersMixin from "@/mixins/ordersMixin";
import metaMixin from './mixins/metaMixin'

Vue.mixin(globalMixin)
Vue.mixin(metaMixin)
Vue.mixin(ordersMixin)

Vue.use(VueRouter)
import router from './router-new.js'
// console.log(process.env.MIX_PUBNUB_PUBLISH_KEY)
// console.log(process.env.MIX_PUBNUB_SUBSCRIBE_KEY)

import VueSocketIOExt from 'vue-socket.io-extended';
import {io} from 'socket.io-client';

//TODO if medzakaz do not start io
export const SocketInstance = io('https://notify.rancond.info', {
// export const SocketInstance = io('https://notify.user435.com', {
  transports: ["websocket"],
  debug: true,
  verify_peer: false,
  reconnection: true
  // options: {
  //   autoConnect: true,
  //   transports: ['websocket'],        // ['websocket', 'polling']
  // pingInterval: 25000,
  // pingTimeout: 5000
  // timeout: 250000,
  // reconnectionDelayMax: 10000,
  // reconnectionDelay: 20000
  // }
});
Vue.use(VueSocketIOExt, SocketInstance)

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.use(VueAxios, axios);
Vue.use(VueScrollTo);
Vue.use(excel);
// Vue.use(constanst);
Vue.component('PulseLoader', PulseLoader);
Vue.component('ClipLoader', ClipLoader);
Vue.component('ScaleLoader', ScaleLoader);

import VueMask from 'v-mask'

Vue.use(VueMask);

require('./bootstrap')

Vue.use(Tabs);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// import CKEditor from '@ckeditor/ckeditor5-vue2';
// Vue.component('CKEditor', CKEditor);

import 'vue-awesome/icons'
/* Register component with one of 2 methods */
import Icon from 'vue-awesome/components/Icon'

Vue.component('v-icon', Icon)


const app = new Vue({
  router,
  store,
  components: {
    // ClipLoader
    // PulseLoader
    ThemeSwitcher
  },
  mounted() {
    this.checkMobile();
  },
  methods: {
    checkMobile() {
      if (this.isMobile() && utils.isRegionDomain(window.location.host)) {
        // this.mixinGoToRouter("RegionMainPage");
      }
    }
  }
});

app.$mount('#app')
